import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Field } from '../components/Field';
import { StateMessage } from '../components/StateMessage';
import { useFormations } from '../data/queries';

export function Membre() {
  const navigate = useNavigate();
  const [logged, setLogged] = useState(false);
  const formationsQ = useFormations();

  if (!logged) {
    return (
      <div className="page-membre-login">
        <div className="mb-login-card">
          <span className="mtc-eyebrow">Espace membre</span>
          <h1>Bienvenue.</h1>
          <p>Connectez-vous pour accéder à vos inscriptions, replays et certificats.</p>
          <Field
            label="Email"
            type="email"
            value=""
            onChange={() => undefined}
            placeholder="vous@cabinet.ma"
          />
          <Field label="Mot de passe" type="password" value="" onChange={() => undefined} />
          <button
            type="button"
            className="mtc-btn mtc-btn-primary mtc-btn-block mtc-btn-lg"
            onClick={() => setLogged(true)}
          >
            Se connecter
          </button>
          <p className="mb-login-help">
            Pas encore de compte ?{' '}
            <button
              type="button"
              className="mtc-btn mtc-btn-link"
              onClick={() => navigate('/inscription')}
            >
              S'inscrire à une formation
            </button>
          </p>
        </div>
      </div>
    );
  }

  if (formationsQ.isLoading) return <StateMessage variant="loading" />;
  const formations = formationsQ.data ?? [];
  const inscriptions = formations.slice(0, 2);
  const passees = formations.slice(3, 5);

  return (
    <div className="page-membre">
      <div className="mb-head">
        <div>
          <span className="mtc-eyebrow">Espace membre</span>
          <h1>Bonjour, Dr. Cherkaoui.</h1>
        </div>
        <button type="button" className="mtc-btn mtc-btn-ghost" onClick={() => setLogged(false)}>
          Se déconnecter
        </button>
      </div>
      <div className="mb-stats">
        <div className="mb-stat">
          <div className="mb-stat-num">2</div>
          <div className="mb-stat-label">Inscriptions à venir</div>
        </div>
        <div className="mb-stat">
          <div className="mb-stat-num">7</div>
          <div className="mb-stat-label">Formations suivies</div>
        </div>
        <div className="mb-stat">
          <div className="mb-stat-num">112h</div>
          <div className="mb-stat-label">Heures cumulées</div>
        </div>
        <div className="mb-stat">
          <div className="mb-stat-num">5</div>
          <div className="mb-stat-label">Certificats</div>
        </div>
      </div>

      <section className="mb-section">
        <h2>Mes prochaines formations</h2>
        <div className="mb-list">
          {inscriptions.map((f) => (
            <div key={f.id} className="mb-row">
              <div className="mb-row-date">
                <span>{new Date(f.dateStart).toLocaleDateString('fr-FR', { day: 'numeric' })}</span>
                <span>{new Date(f.dateStart).toLocaleDateString('fr-FR', { month: 'short' })}</span>
              </div>
              <div className="mb-row-main">
                <h4>{f.titre}</h4>
                <p>
                  {f.lieu} · {f.duree}
                </p>
              </div>
              <div className="mb-row-actions">
                <button type="button" className="mtc-btn mtc-btn-ghost">
                  Brochure
                </button>
                <button
                  type="button"
                  className="mtc-btn mtc-btn-primary"
                  onClick={() => navigate(`/formations/${f.id}`)}
                >
                  Détails
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-section">
        <h2>Mes formations passées</h2>
        <div className="mb-list">
          {passees.map((f) => (
            <div key={f.id} className="mb-row mb-row-past">
              <div className="mb-row-date mb-row-date-past">
                <span>✓</span>
              </div>
              <div className="mb-row-main">
                <h4>{f.titre}</h4>
                <p>
                  Suivie en{' '}
                  {new Date(f.dateStart).toLocaleDateString('fr-FR', {
                    month: 'long',
                    year: 'numeric',
                  })}
                </p>
              </div>
              <div className="mb-row-actions">
                <button type="button" className="mtc-btn mtc-btn-ghost">
                  Replay
                </button>
                <button type="button" className="mtc-btn mtc-btn-ghost">
                  Certificat ↓
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
